export const REQUEST_ANIMALS_PAGE_INFORMATION =
  'REQUEST_ANIMALS_PAGE_INFORMATION';
export const REQUEST_ANIMALS_PAGE_INFORMATION_ERROR =
  'REQUEST_ANIMALS_PAGE_INFORMATION_ERROR';
export const REQUEST_ANIMALS_PAGE_INFORMATION_SUCCESS =
  'REQUEST_ANIMALS_PAGE_INFORMATION_SUCCESS';
export const SAVE_CHANGES_TO_ANIMALS_PAGE =
  'SAVE_CHANGES_TO_ANIMALS_PAGE';
export const SAVE_CHANGES_TO_ANIMALS_PAGE_SUCCESS =
  'SAVE_CHANGES_TO_ANIMALS_PAGE_SUCCESS';
export const SAVE_CHANGES_TO_ANIMALS_PAGE_ERROR =
  'SAVE_CHANGES_TO_ANIMALS_PAGE_ERROR';
